<template>
    <div id="index" ref="appRef">
        <div class="bg">
            <!-- 加载 -->
            <dv-loading v-if="loading">Loading...</dv-loading>
            <div v-else class="host-body">
                <div class="d-flex jc-center">
                    <dv-decoration-10 class="dv-dec-10" />
                    <div class="d-flex jc-center">
                        <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
                        <div class="title">
                            <span class="title-text">福管家智慧酒店能耗系统平台</span>
                            <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" />
                        </div>
                        <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
                    </div>
                    <dv-decoration-10 class="dv-dec-10-s" />
                </div>

                <!-- 第二行 -->
                <div class="d-flex jc-between px-2">
                    <topMenu :cur='2'></topMenu>
                    <div class="d-flex aside-width">
                        <div class="react-right bg-color-blue mr-3">
                            <span class="text fw-b"></span>
                        </div>
                        <div class="react-right mr-4 react-l-s">
                            <span class="react-after"></span>
                            <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
                        </div>
                    </div>
                </div>

                <div class="body-box">
                    <!-- 第一列 -->
                    <div class="left">
                        <dv-border-box13>
                            <div class="d-flex flex-column">
                                <leftTopChart></leftTopChart>
                                <leftMidChart></leftMidChart>
                                <leftBtmChart></leftBtmChart>
                            </div>
                        </dv-border-box13>
                    </div>
                    <div class="mid">
                        <dv-border-box13>
                                <midTopChart></midTopChart>
                                <midMidChart></midMidChart>
                                <midBtmChart></midBtmChart>
                        </dv-border-box13>
                    </div>
                    <div class="right">
                        <dv-border-box13>
                                <rightTopChart></rightTopChart>
                                <rightMidChart></rightMidChart>
                                <rightBtmChart></rightBtmChart>
                        </dv-border-box13>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import topMenu from '@/components/common/top.vue'
import drawMixin from "@/utils/drawMixin";
import { formatTime } from '@/utils/index.js'
import leftTopChart from './left/top.vue'
import leftMidChart from './left/mid.vue'
import leftBtmChart from './left/btm.vue'
import midTopChart from './mid/top.vue'
import midMidChart from './mid/mid.vue'
import midBtmChart from './mid/btm.vue'
import rightTopChart from './right/top.vue'
import rightMidChart from './right/mid.vue'
import rightBtmChart from './right/btm.vue'

export default {
    mixins: [drawMixin],
    data() {
        return {
            timing: null,
            loading: true,
            dateDay: null,
            dateYear: null,
            dateWeek: null,
            weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            decorationColor: ['#568aea', '#000000']
        }
    },
    components: {
        topMenu,
        leftTopChart,
        leftMidChart,
        leftBtmChart,
        midTopChart,
        midMidChart,
        midBtmChart,
        rightTopChart,
        rightMidChart,
        rightBtmChart
    },
    mounted() {
        this.timeFn()
        this.cancelLoading()
    },
    beforeDestroy() {
        clearInterval(this.timing)
    },
    methods: {
        // 计算时间
        timeFn() {
            this.timing = setInterval(() => {
                this.dateDay = formatTime(new Date(), 'HH: mm: ss')
                this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
                this.dateWeek = this.weekday[new Date().getDay()]
            }, 1000)
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false
            }, 500)
        }
    }
}
</script>
  
<style lang="scss" scoped>
#index {
    color: #d3d6dd;
    width: 1920px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        padding: 16px 16px 0 16px;
        background-image: url("~@/assets/pageBg.png");
        background-size: cover;
        background-position: center center;
    }

    .host-body {

        .dv-dec-10,
        .dv-dec-10-s {
            width: 33.3%;
            height: 5px;
        }

        .dv-dec-10-s {
            transform: rotateY(180deg);
        }

        .dv-dec-8 {
            width: 200px;
            height: 50px;
        }

        .title {
            position: relative;
            width: 500px;
            text-align: center;
            background-size: cover;
            background-repeat: no-repeat;

            .title-text {
                font-size: 30px;
                bottom: 15px;
                left: 0;
                right: 0;
                position: absolute;
            }

            .dv-dec-6 {
                position: absolute;
                bottom: -30px;
                left: 50%;
                width: 250px;
                height: 8px;
                transform: translate(-50%);
            }
        }

        // 第二行
        .aside-width {
            width: 40%;
        }

        .react-r-s,
        .react-l-s {
            background-color: #0f1325;
        }

        // 平行四边形
        .react-right {
            &.react-l-s {
                text-align: right;
                width: 500px;
            }

            font-size: 18px;
            width: 300px;
            line-height: 50px;
            text-align: center;
            transform: skewX(-45deg);

            .react-after {
                position: absolute;
                right: -25px;
                top: 0;
                height: 50px;
                width: 50px;
                background-color: #0f1325;
                transform: skewX(45deg);
            }

            .text {
                display: inline-block;
                transform: skewX(45deg);
            }
        }

        .react-left {
            &.react-l-s {
                width: 500px;
                text-align: left;
            }

            font-size: 18px;
            width: 300px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            transform: skewX(45deg);
            background-color: #0f1325;

            .react-left {
                position: absolute;
                left: -25px;
                top: 0;
                height: 50px;
                width: 50px;
                background-color: #0f1325;
                transform: skewX(-45deg);
            }

            .text {
                display: inline-block;
                transform: skewX(-45deg);
            }
        }

        .body-box {
            margin-top: 16px;
            // display: flex;
            // flex-direction: column;
            display: grid;
            grid-template-columns: repeat(3, 33.3%);

            //下方区域的布局
            .content-box {
                display: grid;
                grid-template-columns: 2fr 3fr 5fr 3fr 2fr;
            }

            // 底部数据
            .bottom-box {
                margin-top: 10px;
                display: grid;
                grid-template-columns: repeat(3, 33.3%);
            }
        }
    }
}
</style>
  